import React, { useCallback, useEffect, useRef, useState } from "react";
import { FaTrash } from "react-icons/fa";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import { useSnackbar } from "notistack";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useDispatch, useSelector } from "react-redux";
import { deleteFile, getFilesByLead, uploadFile } from "../../../store/slices/FileDataSlice";
import { fetchFilesByLeadId } from "../../../store/slices/fileSlice";
import { 
    fetchAllQuotations, 
    downloadQuotationFile, 
    deleteQuotation 
} from "../../../store/slices/generateQuotationSlice";
import { fetchLeads } from "../../../store/slices/leadsSlice";


const FinanceFileUpload = ({
    setPopupProject,
    row,
    setOpenDropdownIndex,
    openDropdownIndex,
    isViewOnly = false, }) => {
    const dispatch = useDispatch()
    const { enqueueSnackbar } = useSnackbar();
    // const [popupProject, setPopupProject] = useState(null)
    const id = row._id;
    const [SelectedCategory, setSelectedCategory] = useState("");
    const [showCategoryDropdown, setShowCategoryDropdown] = useState(false);
    const [fileNames, setFileNames] = useState([]);
    const [editfetchedfiles, seteditFetchedFiles] = useState({ payload: [] });
    const auth = localStorage.getItem("auth");
    const { quotations } = useSelector((state) => state.generateQuotation);
    const [quotation, sequotations] = useState([]);
    const [filesToDisplay, sefilesToDisplay] = useState([]);
    const [lead, setlead] = useState("");
    const { leads } = useSelector((state) => state.leads);



    useEffect(() => {
        if (row && leads?.length) {
            const matchedLead = leads?.find(lead => lead?.ProjectName === row?.ProjectName);
            setlead(matchedLead)
        }
    }, [row, leads]);

    // Filter quotations by leadid for finance person (L2)
    useEffect(() => {
        if (auth === "L2" && quotations?.length > 0) {
            const leadId = lead?.id || row?.id;
            if (leadId) {
                const filteredQuotations = quotations.filter((q) => String(q.leadid) === String(leadId));
                sequotations(filteredQuotations);
            } else {
                sequotations([]);
            }
        } else if (auth === "L3") {
            const filteredQuotations = quotations.filter((q) => q.leadid === lead?.id);
            sequotations(filteredQuotations);
        } else {
            sequotations([]);
        }
    }, [quotations, lead, row, auth]);

    useEffect(() => {
        dispatch(fetchAllQuotations());
        dispatch(fetchLeads());
    }, [dispatch]);

    const mapQuotationToFile = (quotationItem, index) => ({
        id: quotationItem._id,
        filename: `quotation_v${index + 1}`,
        filepath: quotationItem.generateddatafilepath?.replace("http://localhost:9000/", "") || "",
        filepathurl: quotationItem.generateddatafilepath || "",
        createdAt: quotationItem.createdAt,
        createdBy: quotationItem.createdBy,
        selectedCategory: "Quote",
        leadId: quotationItem.leadid,
        projectId: null,
        type: "GeneratedQuote",
        quotation: quotationItem, // Store the full quotation object for download/delete
    });

    useEffect(() => {
        if (!editfetchedfiles?.payload) return;

        let updatedFiles = [...editfetchedfiles.payload];

        // Show quotations for L2 (Finance) and L3 (Sales)
        if (auth === "L2" || auth === "L3") {
            if (Array.isArray(quotation) && quotation.length > 0) {
                const quotationFiles = quotation.map((item, index) =>
                    mapQuotationToFile(item, index)
                );

                // Add quotation at FIRST position
                updatedFiles = [...quotationFiles, ...updatedFiles];
            }

            sefilesToDisplay(updatedFiles);
        } else {
            sefilesToDisplay(updatedFiles);
        }

    }, [editfetchedfiles, auth, quotation]);


    useEffect(() => {
        const fetchFiles = async () => {
            try {
                const files = await dispatch(getFilesByLead(id)).unwrap();
                // Ensure we always have a payload array
                seteditFetchedFiles(Array.isArray(files) ? { payload: files } : files);
            } catch (err) {
                console.error("Error fetching files:", err);
            }
        };

        fetchFiles();
    }, [dispatch, id]);

    const dropdownRefProbability = useRef(null);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                dropdownRefProbability.current &&
                !dropdownRefProbability.current.contains(event.target)
            ) {
                setShowCategoryDropdown(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    // const handleFileDownload = (file) => {
    //   if (!(file instanceof File)) {
    //     enqueueSnackbar("Invalid file object", { variant: "error" });
    //     return;
    //   }

    //   const blobUrl = URL.createObjectURL(file);

    //   const link = document.createElement("a");
    //   link.href = blobUrl;
    //   link.download = file.name || "download";
    //   document.body.appendChild(link);
    //   link.click();
    //   document.body.removeChild(link);
    //   URL.revokeObjectURL(blobUrl); // Clean up the object URL

    //   enqueueSnackbar("File downloaded successfully", {
    //     variant: "success",
    //   });
    // };

    // const handleFileDelete = (projectName, fileNameToDelete) => {
    //   setFileNames((prev) => {
    //     const existingFiles = prev[projectName] || [];

    //     // Filter out the file with the given name
    //     const updatedFiles = existingFiles.filter(
    //       (file) => file.name !== fileNameToDelete
    //     );

    //     return {
    //       ...prev,
    //       [projectName]: updatedFiles,
    //     };
    //   });

    //   enqueueSnackbar("File deleted successfully", {
    //     variant: "success",
    //   });
    // };

    // const handleFileChange = (e) => {
    //   const selectedFiles = Array.from(e.target.files);
    //   const maxSize = 2 * 1024 * 1024; // 2MB
    //   const allowedFormats = [
    //     "application/pdf",
    //     "application/msword",
    //     "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    //   ];

    //   if (!SelectedCategory) {
    //     enqueueSnackbar("Please select a category first", {
    //       variant: "error",
    //     });
    //     return;
    //   }

    //   setFileNames((prev) => {
    //     const existing = prev[popupProject] || [];
    //     const validFiles = [];

    //     selectedFiles.forEach((file) => {
    //       if (!allowedFormats.includes(file.type)) {
    //         enqueueSnackbar("Only PDF and DOC files are allowed", {
    //           variant: "error",
    //         });
    //         return;
    //       }

    //       if (file.size > maxSize) {
    //         enqueueSnackbar(
    //           "File size exceeds 2MB! Please upload a smaller file.",
    //           {
    //             variant: "error",
    //           }
    //         );
    //         return;
    //       }

    //       const isDuplicate = existing.some(
    //         (existingFile) =>
    //           existingFile.name === file.name && existingFile.size === file.size
    //       );

    //       if (isDuplicate) {
    //         enqueueSnackbar(`File "${file.name}" is already uploaded.`, {
    //           variant: "error",
    //         });
    //         return;
    //       }

    //       // Add category directly to the File object
    //       const fileWithCategory = new File([file], file.name, {
    //         type: file.type,
    //         lastModified: file.lastModified,
    //       });
    //       fileWithCategory.selectedCategory = SelectedCategory;

    //       validFiles.push(fileWithCategory);
    //     });

    //     if (validFiles.length === 0) return prev;

    //     return {
    //       ...prev,
    //       [popupProject]: [...existing, ...validFiles],
    //     };
    //   });

    //   // Reset the category dropdown
    //   setSelectedCategory("");
    //   // Reset the file input
    //   e.target.value = null;
    // };

    const handleFileDownload = (fileData) => {
        if (isViewOnly) return;
        try {
            if (!fileData || !fileData.filepathurl) {
                throw new Error("Invalid file data");
            }

            const fileUrl = fileData.filepathurl;
            const fileName = fileData.filename || fileUrl.split("/").pop();

            const link = document.createElement("a");
            link.href = fileUrl;
            link.setAttribute("download", fileName);
            link.setAttribute("target", "_blank");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            enqueueSnackbar("File download started", { variant: "success" });
        } catch (error) {
            console.error("Download failed:", error);
            enqueueSnackbar("Failed to download file", { variant: "error" });
        }
    };

    const handleFileChange = (e) => {
        if (isViewOnly) return;
        const selectedFiles = Array.from(e.target.files);
        const allowedFormats = [
            "application/pdf",
            "application/msword",
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            "application/vnd.ms-excel",
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        ];

        if (!SelectedCategory) {
            enqueueSnackbar("Please select a category first", {
                variant: "error",
            });
            return;
        }

        setFileNames((prev) => {
            const existing = Array.isArray(prev) ? prev : [];
            const validFiles = [];

            selectedFiles.forEach((file) => {
                if (!allowedFormats.includes(file.type)) {
                    enqueueSnackbar(`Only PDF, DOC, DOCX, XLS, and XLSX files are allowed (${file.name})`, {
                        variant: "error",
                    });
                    return;
                }

                const isDuplicate = [
                    ...existing,
                    ...(editfetchedfiles?.payload || [])
                ].some(
                    (f) => f.name === file.name ||
                        (f.filepath && f.filepath.split('/').pop() === file.name)
                );

                if (isDuplicate) {
                    enqueueSnackbar(`File "${file.name}" is already uploaded`, {
                        variant: "error",
                    });
                    return;
                }

                const fileWithCategory = new File([file], file.name, {
                    type: file.type,
                    lastModified: file.lastModified,
                });
                fileWithCategory.selectedCategory = SelectedCategory;
                validFiles.push(fileWithCategory);
            });

            if (validFiles.length === 0) return prev;

            seteditFetchedFiles((prevFetched) => {
                const currentFiles = prevFetched?.payload || [];

                const newFiles = validFiles.map((file) => ({
                    id: `temp-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
                    filepath: `uploads/filesdata/${file.name}`,
                    filepathurl: URL.createObjectURL(file),
                    leadId: id,
                    selectedCategory: file.selectedCategory,
                    isNew: true,
                    name: file.name,
                    type: file.type
                }));

                handleFileUpload(id, newFiles);


                return {
                    ...prevFetched,
                    payload: [...currentFiles, ...newFiles]
                };

            });

            return [...existing, ...validFiles];
        });

        setSelectedCategory("");
        e.target.value = null;
    };


    const handleFileUpload = useCallback(
        async (id, newFiles) => {
            if (!newFiles || newFiles.length === 0) return;

            const uploadDate = new Date().toISOString().slice(0, 10);
            const formData = new FormData();
            formData.append("leadId", row._id);
            formData.append("uploadDate", uploadDate);

            try {
                // For each file, we need to fetch the actual file data from the blob URL
                for (const fileObj of newFiles) {
                    // Fetch the file data from the blob URL
                    const response = await fetch(fileObj.filepathurl);
                    const blob = await response.blob();

                    // Create a new File object from the blob
                    const file = new File([blob], fileObj.name, { type: fileObj.type });

                    // Append to FormData
                    formData.append("selectedCategory", fileObj.selectedCategory);
                    formData.append("files", file);
                }

                await dispatch(uploadFile(formData)).unwrap();
                dispatch(fetchFilesByLeadId(id));
                enqueueSnackbar("File uploaded successfully", { variant: "success" });
            } catch (error) {
                enqueueSnackbar("Error occurred while uploading file", {
                    variant: "error",
                });
                console.error(
                    "Error uploading file:",
                    error.response?.data?.error || error.message
                );
            }
        },
        [dispatch, enqueueSnackbar, row]
    );

    const handleFileDelete = async (file) => {
        if (isViewOnly) return;
        const id = file.id;

        try {
            await dispatch(deleteFile(id)).unwrap();

            // Update state by removing the deleted file
            seteditFetchedFiles(prev => ({
                ...prev,
                payload: prev.payload.filter(f => f.id !== id)
            }));

            enqueueSnackbar("File deleted successfully", { variant: "success" });
        } catch (error) {
            enqueueSnackbar("Error occurred while deleting file", { variant: "error" });
            console.error("Error deleting file:", error);
        }
    };

    // Handle quotation download
    const handleQuotationDownload = async (quotation) => {
        if (isViewOnly) return;
        try {
            const { downloadUrl } = await dispatch(
                downloadQuotationFile(quotation._id)
            ).unwrap();
            const link = document.createElement("a");
            link.href = downloadUrl;
            link.setAttribute("download", `${quotation.quotationNumber || "quotation"}.pdf`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            if (downloadUrl) window.URL.revokeObjectURL(downloadUrl);
            enqueueSnackbar("Quotation download started", { variant: "success" });
        } catch (error) {
            enqueueSnackbar("Failed to download quotation", { variant: "error" });
            console.error("Quotation download failed:", error);
        }
    };

    // Handle quotation delete
    const handleQuotationDelete = async (quotation) => {
        if (isViewOnly) return;
        try {
            await dispatch(deleteQuotation(quotation._id)).unwrap();
            // Remove from quotation state
            sequotations(prev => prev.filter(q => q._id !== quotation._id));
            // Refresh quotations list
            dispatch(fetchAllQuotations());
            enqueueSnackbar("Quotation deleted successfully", { variant: "success" });
        } catch (error) {
            enqueueSnackbar("Error occurred while deleting quotation", { variant: "error" });
            console.error("Error deleting quotation:", error);
        }
    };

    // Get the files to display - always use the payload array
    // const filesToDisplay = editfetchedfiles?.payload || [];
    return (
        <div>
            {/* <AttachFileIcon
                onClick={() => {
                    setPopupProject(row.ProjectName);
                    setOpenDropdownIndex(openDropdownIndex === null);
                }} // open popup for this project
                className="cursor-pointer rotate-12"
            /> */}


            {/* {popupProject === row.ProjectName && ( */}
            <div className="fixed w-full inset-0 bg-black/50 flex items-center justify-center z-[999]">
                <div className="w-[50%] bg-white shadow-lg rounded-lg p-6">
                    <div className="flex justify-between items-center mb-6">
                        <div className="flex align-middle items-center gap-2">
                            <h2 className="text-lg font-bold">Attachments </h2>
                            <p>({"Project Name : "}{row.ProjectName})</p>
                        </div>
                        <button
                            className="text-gray-500 hover:text-black"
                            onClick={() => setPopupProject(null)}
                        >
                            Close
                        </button>
                    </div>
                    <div className="flex gap-2">
                        <div className="relative bg-white">
                            <div
                                ref={dropdownRefProbability}
                                className=" flex text-xs  p-0 rounded-xl align-middle "
                            >
                                <button
                                    type="button"
                                    disabled={isViewOnly}
                                    onClick={() => {
                                        if (isViewOnly) return;
                                        setShowCategoryDropdown(!showCategoryDropdown);
                                    }}
                                    className={`border relative w-24 border-gray-400 text-nowrap rounded-md p-2 shadow-md overflow-hidden bg-gray-200 outline-none ${isViewOnly ? "opacity-50 cursor-not-allowed" : ""}`}
                                >
                                    <p className="text-left">
                                        {SelectedCategory ? SelectedCategory : "Category"}
                                    </p>
                                    <ExpandMoreIcon
                                        color="white"
                                        className={`absolute cursor-pointer right-0 top-1 bg-gray-200`}
                                    />
                                </button>

                                {showCategoryDropdown && (
                                    <div
                                        style={{ zIndex: 9999 }}
                                        className="absolute top-full left-0 w-40 p-1 cursor-pointer max-h-96 overflow-y-auto bg-white text-sm border border-gray-300 shadow-lg flex flex-col gap-1"
                                    >
                                        {(auth === "L2" || auth === "L3") && (
                                            <div
                                                className="p-1 hover:bg-gray-200 cursor-pointer"
                                                onClick={() => {
                                                    setSelectedCategory("Quote");
                                                    setShowCategoryDropdown(!showCategoryDropdown);
                                                }}
                                            >
                                                Quote
                                            </div>
                                        )}
                                        <div
                                            className="p-1 hover:bg-gray-200 cursor-pointer"
                                            onClick={() => {
                                                setSelectedCategory("Purchase Order");
                                                setShowCategoryDropdown(!showCategoryDropdown);
                                            }}
                                        >
                                            Purchase Order
                                        </div>

                                        <div
                                            className="p-1 hover:bg-gray-200 cursor-pointer"
                                            onClick={() => {
                                                setSelectedCategory("Contract");
                                                setShowCategoryDropdown(!showCategoryDropdown);
                                            }}
                                        >
                                            Contract
                                        </div>
                                        {/* <div
                                            className="p-1 hover:bg-gray-200 cursor-pointer"
                                            onClick={() => {
                                                setSelectedCategory("Communication");
                                                setShowCategoryDropdown(!showCategoryDropdown);
                                            }}
                                        >
                                            Communication
                                        </div>
                                        <div
                                            className="p-1 hover:bg-gray-200 cursor-pointer"
                                            onClick={() => {
                                                setSelectedCategory("Miscellaneous");
                                                setShowCategoryDropdown(!showCategoryDropdown);
                                            }}
                                        >
                                            Miscellaneous
                                        </div> */}
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="flex items-center">
                            <label
                                className={`text-xs p-2 w-24 h-8 text-center flex items-center justify-center rounded-md ${isViewOnly
                                    ? "bg-gray-300 text-gray-600 cursor-not-allowed opacity-50 pointer-events-none"
                                    : !SelectedCategory
                                        ? "bg-gray-300 text-gray-600 cursor-not-allowed"
                                        : "bg-gray-800 text-white hover:text-black hover:bg-gray-300 cursor-pointer"
                                    }`}
                            >
                                <span>Upload File</span>
                                <input
                                    type="file"
                                    multiple
                                    className="hidden"
                                    onChange={(e) => handleFileChange(e)}
                                    disabled={isViewOnly || !SelectedCategory}
                                />
                            </label>

                            <p className="truncate text-xs pl-1">
                                {fileNames?.name || "No file selected"}
                            </p>
                            <div className="flex gap-2 text-red-500 text-[12px] pl-3">
                                <p> only .pdf and .docx allowed</p>
                            </div>
                        </div>
                    </div>
                    <div className="w-full mt-4 text-left border-collapse text-[13px]">
                        <div>
                            <div className="border-b flex w-full">
                                <div className="py-2 px-4 w-[15%]">Sr. No.</div>
                                <div className="py-2 px-4 w-[40%]">File Name</div>
                                <div className="py-2 px-4 text-center w-[15%]">Category</div>
                                <div className="py-2 px-4 text-center w-[15%]">Download</div>
                                <div className="py-2 px-4 text-center w-[15%]">Delete</div>
                            </div>
                        </div>
                        <div>
                            {filesToDisplay
                                .filter(file => {
                                    const category = file.category || file.selectedCategory;
                                    // For finance person (L2), show Quote, Purchase Order, and Contract
                                    if (auth === "L2") {
                                        return category === "Quote" || category === "Purchase Order" || category === "Contract";
                                    }
                                    // For others, show Purchase Order and Contract
                                    return category === "Purchase Order" || category === "Contract";
                                })
                                .map((file, index) => {
                                    const isQuotation = file.type === "GeneratedQuote" || file.selectedCategory === "Quote";
                                    const quotationData = file.quotation || (isQuotation ? quotation.find(q => q._id === file.id) : null);
                                    
                                    return (
                                        <div className="border-b flex w-full" key={file.id ?? index}>
                                            <div className="py-2 px-4 w-[15%]">{index + 1}</div>
                                            <div className="py-2 px-4 w-[40%] truncate overflow-hidden">
                                                {file.filename || file.name || "quotation"}
                                            </div>
                                            <div className="py-2 px-4 w-[15%] text-center truncate">
                                                {file.category || file.selectedCategory || "Quote"}
                                            </div>
                                            <div className="py-2 px-4 text-center w-[15%]">
                                                <button
                                                    onClick={() => {
                                                        if (!isViewOnly) {
                                                            if (isQuotation && quotationData) {
                                                                handleQuotationDownload(quotationData);
                                                            } else {
                                                                handleFileDownload(file);
                                                            }
                                                        }
                                                    }}
                                                    disabled={isViewOnly}
                                                    className={`text-white px-2 py-1 rounded ${isViewOnly ? "bg-blue-500 opacity-50 cursor-not-allowed" : "bg-blue-500 hover:bg-blue-700"}`}
                                                >
                                                    <CloudDownloadIcon />
                                                </button>
                                            </div>
                                            <div className="py-2 px-4 text-center w-[15%]">
                                                <button
                                                    onClick={() => {
                                                        if (isViewOnly) return;
                                                        if (isQuotation && quotationData) {
                                                            handleQuotationDelete(quotationData);
                                                        } else {
                                                            handleFileDelete(file);
                                                        }
                                                    }}
                                                    disabled={isViewOnly}
                                                    className={`text-white px-2 py-2 rounded ${isViewOnly ? "bg-red-500 opacity-50 cursor-not-allowed" : "bg-red-500 hover:bg-red-700"}`}
                                                >
                                                    <FaTrash size={18} />
                                                </button>
                                            </div>
                                        </div>
                                    );
                                })}
                        </div>
                    </div>
                </div>
            </div>
            {/* )} */}
        </div>
    )
}

export default FinanceFileUpload